import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import authApi from "../api/auth";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("smartmoms_user"));
    } catch {
      return null;
    }
  });
  const [role, setRole] = useState(() =>
    localStorage.getItem("smartmoms_role"),
  ); // 'admin' | 'user'
  const [token, setToken] = useState(() =>
    localStorage.getItem("smartmoms_token"),
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const logout = useCallback(async (callApi = true) => {
    if (callApi) {
      try {
        await authApi.logout();
      } catch {
        /* abaikan */
      }
    }
    localStorage.removeItem("smartmoms_token");
    localStorage.removeItem("smartmoms_user");
    localStorage.removeItem("smartmoms_role");
    setToken(null);
    setUser(null);
    setRole(null);
  }, []);

  useEffect(() => {
    const handler = () => logout(false);
    window.addEventListener("auth:logout", handler);
    return () => window.removeEventListener("auth:logout", handler);
  }, [logout]);

  // Login admin
  const loginAdmin = async (email, password) => {
    setError("");
    setLoading(true);
    try {
      const res = await authApi.loginAdmin(email, password);
      const { token: newToken, admin: newUser } = res.data.data;
      localStorage.setItem("smartmoms_token", newToken);
      localStorage.setItem("smartmoms_user", JSON.stringify(newUser));
      localStorage.setItem("smartmoms_role", "admin");
      setToken(newToken);
      setUser(newUser);
      setRole("admin");
      return { success: true };
    } catch (err) {
      const msg = err.response?.data?.message || "Login gagal";
      setError(msg);
      return { success: false, message: msg };
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        role,
        loading,
        error,
        loginAdmin,
        logout,
        isLoggedIn: !!token,
        isAdmin: role === "admin",
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth harus dipakai di dalam AuthProvider");
  return ctx;
}
